import * as React from 'react';
import classNames from "classnames";
import { AppFullHeight } from "../App";
import style from './Card.scss';

type Props = {
  className?: string,
  title?: React.ReactNode | (() => React.ReactNode),
  actions?: React.ReactNode | (() => React.ReactNode),
  children?: React.ReactNode,
  fullHeight?: boolean,
  flex?: boolean,
  rawBody?: boolean,
};
type State = {};

export default function Card(props: Props) {
  const { className, title, actions, children, fullHeight, rawBody, flex } = props;

  const finalTitle = typeof title === 'function' ? title() : title;
  const finalActions = typeof actions === 'function' ? actions() : actions;

  return (
    <div className={classNames(style.container, (fullHeight || flex) && style.containerFullHeight, className)}>
      {fullHeight && <AppFullHeight />}
      {(finalTitle || finalActions) && (
        <div className={style.header}>
          {finalTitle && <h6 className={style.title}>{finalTitle}</h6>}
          {finalActions && <div className={style.actions}>{finalActions}</div>}
        </div>
      )}

      {children && (
        rawBody ? children : <div className={style.body}>{children}</div>
      )}
    </div>
  );
}
